export default "/images/SL_dessus.png?43f2fcf33a28a97fb89ad9085992ddb9";